import React, { useContext, useEffect, useReducer, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useHelps from "../hooks/useHelps";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Popover from "@material-ui/core/Popover";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";
import NotificationsIcon from "@material-ui/icons/Notifications";

// Ícones modernos e consistentes
import DashboardIcon from "@mui/icons-material/Dashboard";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkIcon from "@mui/icons-material/Link";
import TuneIcon from "@mui/icons-material/Tune";
import ContactsIcon from "@mui/icons-material/Contacts";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import BoltIcon from "@mui/icons-material/Bolt";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CodeIcon from "@mui/icons-material/Code";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import CallIcon from "@mui/icons-material/Call";
import CampaignIcon from "@mui/icons-material/Campaign";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CakeIcon from "@mui/icons-material/Cake";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import BusinessIcon from "@mui/icons-material/Business";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import CachedIcon from "@mui/icons-material/Cached";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import ContrastIcon from "@mui/icons-material/Contrast";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import MessageIcon from "@mui/icons-material/Message";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import ForumIcon from "@mui/icons-material/Forum";
import TornadoIcon from "@mui/icons-material/Tornado";
import TodayIcon from "@mui/icons-material/Today";
import OfflineBoltIcon from "@mui/icons-material/OfflineBolt";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import {
  AllInclusive,
  AttachFile,
  Description,
  DeviceHub,
  GridView,
  PhoneAndroid,
  Analytics,
  Business,
  LocalOffer,
  ShoppingCart,
  BookmarkBorder,
  ListAlt,
  TextFields,
  GridOn,
  AccessTime,
  Category,
  Extension,
  Wifi,
  CreditCard,
  Help,
  Palette,
  Storage,
} from "@mui/icons-material";

import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { useActiveMenu } from "../context/ActiveMenuContext";
import ColorModeContext from "./themeContext";

import { Can } from "../components/Can";

import { isArray } from "lodash";
import api from "../services/api";
import toastError from "../errors/toastError";
import usePlans from "../hooks/usePlans";
import useVersion from "../hooks/useVersion";
import { i18n } from "../translate/i18n";
import { Campaign, Timeline, Webhook, AutoAwesome, BarChart, Assessment, PlaylistAdd, ContactMail, Tune, AutoGraph, SmartToy, IntegrationInstructions, CloudQueue } from "@mui/icons-material";

import useCompanySettings from "../hooks/useSettings/companySettings";

const useStyles = makeStyles((theme) => ({
  listItem: {
    minHeight: "44px",
    height: "auto",
    margin: "4px 8px",
    borderRadius: "10px",
    padding: "8px 10px",
    position: "relative",
    overflow: "hidden",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    backgroundColor: "transparent",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: "3px",
      backgroundColor: "transparent",
      transition: "all 0.3s ease",
      borderRadius: "0 3px 3px 0",
    },
    "&:hover": {
      backgroundColor: (props) => `${props.listItemBgColor || (theme.mode === "light" 
        ? "rgba(0, 0, 0, 0.06)" 
        : "rgba(255, 255, 255, 0.1)")} !important`,
      transform: "translateX(4px)",
      "&::before": {
        backgroundColor: theme.palette.primary.main,
        width: "4px",
      },
      "& $iconContainer": {
        backgroundColor: "transparent",
        color: theme.palette.primary.main,
        transform: "scale(1.08)",
        boxShadow: "none",
      },
      "& $listItemText": {
        color: theme.palette.primary.main,
        fontWeight: 500,
      },
    },
    "&.active": {
      backgroundColor: (props) => `${props.listItemBgColor || (theme.mode === "light"
        ? `${theme.palette.primary.main}12`
        : `${theme.palette.primary.main}20`)} !important`,
      "&::before": {
        backgroundColor: theme.palette.primary.main,
        width: "4px",
      },
      "& $iconContainer": {
        backgroundColor: "transparent",
        color: theme.palette.primary.main,
        boxShadow: "none",
      },
      "& $listItemText": {
        color: theme.palette.primary.main,
        fontWeight: 600,
      },
    },
    "&.collapsed": {
      margin: "6px 12px",
      padding: "10px 8px",
      justifyContent: "center",
      "&:hover": {
        transform: "scale(1.05)",
      },
    },
  },

  listItemText: {
    fontSize: "13px",
    color: theme.mode === "light" ? "#64748b" : "#e2e8f0",
    transition: "all 0.3s ease",
    fontWeight: 400,
    letterSpacing: "0.01em",
    fontFamily: "'Geist', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', sans-serif",
    "& .MuiTypography-root": {
      fontFamily: "'Geist', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', sans-serif",
      fontSize: "13px",
      fontWeight: 400,
    }
  },

  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "10px",
    height: 28,
    width: 28,
    minWidth: 28,
    backgroundColor: "transparent",
    color: theme.mode === "light" ? "#475569" : "#cbd5e1",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
      transition: "transform 0.3s ease",
    },
    "&.active": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
      boxShadow: "none",
    },
  },

  badge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#ef4444",
      color: "#fff",
      fontSize: "0.7rem",
      fontWeight: 700,
      minWidth: "18px",
      height: "18px",
      padding: "0 4px",
      animation: "$pulse 2s infinite",
      boxShadow: "0 2px 8px rgba(239, 68, 68, 0.4)",
    }
  },

  "@keyframes pulse": {
    "0%, 100%": {
      opacity: 1,
      transform: "scale(1)",
    },
    "50%": {
      opacity: 0.8,
      transform: "scale(1.05)",
    }
  },

  submenuContainer: {
    backgroundColor: theme.mode === "light"
      ? "rgba(0, 0, 0, 0.02)"
      : "rgba(255, 255, 255, 0.03)",
    paddingLeft: "0",
    marginLeft: "0",
    borderLeft: `3px solid ${theme.palette.primary.main}40`,
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },

  submenuItem: {
    minHeight: "36px",
    margin: "2px 8px",
    borderRadius: "8px",
    paddingLeft: "16px !important",
    backgroundColor: "transparent",
    transition: "all 0.3s ease",
    fontSize: "13px",
    "&:hover": {
      backgroundColor: (props) => `${props.listItemBgColor || (theme.mode === "light"
        ? "rgba(0, 0, 0, 0.05)"
        : "rgba(255, 255, 255, 0.08)")} !important`,
      transform: "translateX(2px)",
    },
    "&.active": {
      backgroundColor: (props) => `${props.listItemBgColor || (theme.mode === "light"
        ? "rgba(0, 0, 0, 0.08)"
        : "rgba(255, 255, 255, 0.12)")} !important`,
      borderLeft: `3px solid ${theme.palette.primary.main}`,
      paddingLeft: "13px !important",
    },
  },

  customTooltip: {
    backgroundColor: theme.mode === "light" ? "#1e293b" : "#0f172a",
    color: "#fff",
    fontSize: "0.8125rem",
    fontWeight: 500,
    borderRadius: "8px",
    padding: "6px 12px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
    "& .MuiTooltip-arrow": {
      color: theme.mode === "light" ? "#1e293b" : "#0f172a",
    }
  },

  versionContainer: {
    textAlign: "center",
    padding: "16px",
    color: theme.mode === "light" ? "#94a3b8" : "#64748b",
    fontSize: "11px",
    fontWeight: 600,
    borderTop: `1px solid ${theme.mode === "light" ? "rgba(0, 0, 0, 0.08)" : "rgba(255, 255, 255, 0.1)"}`,
    marginTop: "auto",
    letterSpacing: "0.5px",
  },

  adminSection: {
    marginTop: "8px",
    "& .MuiListSubheader-root": {
      color: theme.mode === "light" ? "#64748b" : "#94a3b8",
      fontSize: "0.75rem",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "1px",
      padding: "16px 16px 8px",
      lineHeight: 1.5,
    }
  },

  expandIcon: {
    transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    color: theme.mode === "light" ? "#94a3b8" : "#64748b",
    fontSize: "20px !important",
    "&.expanded": {
      transform: "rotate(180deg)",
    }
  },

  menuSection: {
    marginBottom: "8px",
  },

  menuContainer: {
    overflowY: "auto",
    padding: "8px 0",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.mode === "light"
        ? "rgba(0, 0, 0, 0.12)"
        : "rgba(255, 255, 255, 0.12)",
      borderRadius: "3px",
      "&:hover": {
        background: theme.mode === "light"
          ? "rgba(0, 0, 0, 0.2)"
          : "rgba(255, 255, 255, 0.2)",
      }
    },
  },

  divider: {
    margin: "12px 16px",
    borderColor: theme.mode === "light" 
      ? "rgba(0, 0, 0, 0.08)" 
      : "rgba(255, 255, 255, 0.1)",
  },

  iconsContainer: {
    display: "flex",
    gap: "8px",
    flexWrap: "nowrap",
    overflow: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    [theme.breakpoints.up("sm")]: {
      overflow: "visible",
      flexWrap: "wrap",
    },
  },
}));

function ListItemLink(props) {
  const { icon, primary, to, tooltip, showBadge, small, onItemClick } = props;
  const { colorMode } = useContext(ColorModeContext);
  const classes = useStyles({ listItemBgColor: colorMode.listItemBgColor });
  const { activeMenu } = useActiveMenu();
  const location = useLocation();
  
  // Verificar se está ativo: apenas pelo pathname exato
  const isActive = location.pathname === to || location.pathname.startsWith(to + '/');

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink 
          to={to} 
          ref={ref} 
          {...itemProps} 
          onClick={(e) => {
            // Chamar onItemClick se fornecido
            if (onItemClick) {
              onItemClick();
            }
            // Manter comportamento original se houver
            if (itemProps.onClick) {
              itemProps.onClick(e);
            }
          }}
        />
      )),
    [to, onItemClick]
  );

  const ConditionalTooltip = ({ children, tooltipEnabled }) =>
    tooltipEnabled ? (
      <Tooltip title={primary} placement="right">
        {children}
      </Tooltip>
    ) : (
      children
    );

  return (
    <ConditionalTooltip tooltipEnabled={!!tooltip}>
      <li>
        <ListItem 
          button 
          component={renderLink} 
          className={`${small ? classes.submenuItem : classes.listItem} ${isActive ? "active" : ""} ${tooltip ? "collapsed" : ""}`}
        >
          {icon ? (
            <ListItemIcon style={{ minWidth: tooltip ? "auto" : "56px", justifyContent: "center" }}>
              {showBadge ? (
                <Badge
                  badgeContent="!"
                  color="error"
                  overlap="circular"
                  className={classes.badge}
                >
                  <div
                    className={`${classes.iconContainer} ${isActive ? "active" : ""}`}
                  >
                    {icon}
                  </div>
                </Badge>
              ) : (
                <div
                  className={`${classes.iconContainer} ${isActive ? "active" : ""}`}
                >
                  {icon}
                </div>
              )}
            </ListItemIcon>
          ) : null}
          {!tooltip && (
            <ListItemText
              primary={
                <Typography className={classes.listItemText}>
                  {primary}
                </Typography>
              }
            />
          )}
        </ListItem>
      </li>
    </ConditionalTooltip>
  );
}

const reducer = (state, action) => {
  if (action.type === "LOAD_CHATS") {
    const chats = action.payload;
    const newChats = [];

    if (isArray(chats)) {
      chats.forEach((chat) => {
        const chatIndex = state.findIndex((u) => u.id === chat.id);
        if (chatIndex !== -1) {
          state[chatIndex] = chat;
        } else {
          newChats.push(chat);
        }
      });
    }

    return [...state, ...newChats];
  }

  if (action.type === "UPDATE_CHATS") {
    const chat = action.payload;
    const chatIndex = state.findIndex((u) => u.id === chat.id);

    if (chatIndex !== -1) {
      state[chatIndex] = chat;
      return [...state];
    } else {
      return [chat, ...state];
    }
  }

  if (action.type === "DELETE_CHAT") {
    const chatId = action.payload;

    const chatIndex = state.findIndex((u) => u.id === chatId);
    if (chatIndex !== -1) {
      state.splice(chatIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "CHANGE_CHAT") {
    const changedChats = state.map((chat) => {
      if (chat.id === action.payload.chat.id) {
        return action.payload.chat;
      }
      return chat;
    });
    return changedChats;
  }
};

const MainListItems = ({ collapsed, drawerClose, onItemClick, onPhoneClick, onRefresh, onThemeToggle, onProfileClick, onLogout, profileUrl, user, theme, onChatClick, onInformativos, ticketsCount, chatsCount }) => {
  const { colorMode } = useContext(ColorModeContext);
  const classes = useStyles({ listItemBgColor: colorMode.listItemBgColor });
  const { whatsApps } = useContext(WhatsAppsContext);
  const { socket } = useContext(AuthContext);

  const { setActiveMenu } = useActiveMenu();
  const location = useLocation();

  const [connectionWarning, setConnectionWarning] = useState(false);
  const [openCampaignSubmenu, setOpenCampaignSubmenu] = useState(false);
  const [openDashboardSubmenu, setOpenDashboardSubmenu] = useState(false);
  const [openSchedulingSubmenu, setOpenSchedulingSubmenu] = useState(false);
  const [openCrmSubmenu, setOpenCrmSubmenu] = useState(false);
  const [openConfiguracoesSubmenu, setOpenConfiguracoesSubmenu] = useState(false);
  const [openGerenciaSubmenu, setOpenGerenciaSubmenu] = useState(false);
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showKanban, setShowKanban] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const [showWavoipCall, setShowWavoipCall] = useState(false);

  // novas features
  const [showSchedules, setShowSchedules] = useState(false);
  const [showInternalChat, setShowInternalChat] = useState(false);
  const [showExternalApi, setShowExternalApi] = useState(false);

  const [invisible, setInvisible] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam] = useState("");
  const [chats, dispatch] = useReducer(reducer, []);
  const [version, setVersion] = useState(false);
  const [managementHover, setManagementHover] = useState(false);
  const [campaignHover, setCampaignHover] = useState(false);
  const [crmHover, setCrmHover] = useState(false);
  const [configuracoesHover, setConfiguracoesHover] = useState(false);
  const [gerenciaHover, setGerenciaHover] = useState(false);
  const { list } = useHelps(); // INSERIR
  const [hasHelps, setHasHelps] = useState(false);

  const [openFlowSubmenu, setOpenFlowSubmenu] = useState(false);
  const [flowHover, setFlowHover] = useState(false);
  const [schedulingHover, setSchedulingHover] = useState(false);

  const { get: getSetting } = useCompanySettings();
  const [showWallets, setShowWallets] = useState(false);
  
  const [audioEnabled, setAudioEnabled] = useState(() => {
    const saved = localStorage.getItem("audioEnabled");
    return saved !== null ? JSON.parse(saved) : true;
  });

  const [volume, setVolume] = useState(() => {
    const saved = localStorage.getItem("volume");
    return saved !== null ? parseFloat(saved) : 0.5;
  });

  const [volumeAnchor, setVolumeAnchor] = useState(null);

  const [languageAnchor, setLanguageAnchor] = useState(null);
  const [enabledLanguages, setEnabledLanguages] = useState(["pt-BR", "en"]);

  const LANGUAGE_OPTIONS = [
    { code: "pt-BR", label: "Português" },
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    { code: "ar", label: "العربية" },
  ];

  const isFlowbuilderRouteActive =
    location.pathname.startsWith("/phrase-lists");
  location.pathname.startsWith("/flowbuilders");

  useEffect(() => {
    // INSERIR ESSE EFFECT INTEIRO
    async function checkHelps() {
      const helps = await list();
      setHasHelps(helps.length > 0);
    }
    checkHelps();
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const setting = await getSetting(
          {
            "column": "DirectTicketsToWallets"
          }
        );

        setShowWallets(setting.DirectTicketsToWallets);

      } catch (err) {
        toastError(err);
      }
    }

    fetchSettings();
  }, [setShowWallets]);

  const isManagementActive =
    location.pathname === "/" ||
    location.pathname.startsWith("/reports") ||
    location.pathname.startsWith("/moments");

  const isCampaignRouteActive =
    location.pathname === "/campaigns" ||
    location.pathname.startsWith("/contact-lists");

  const isSchedulingActive =
    location.pathname.startsWith("/schedules") ||
    location.pathname.startsWith("/calcom-integration");

  const isCrmActive =
    location.pathname.startsWith("/kanban") ||
    location.pathname.startsWith("/tags") ||
    location.pathname.startsWith("/contacts") ||
    location.pathname.startsWith("/wallets") ||
    location.pathname.startsWith("/quick-messages") ||
    location.pathname.startsWith("/call-historicals") ||
    location.pathname.startsWith("/queues") ||
    location.pathname.startsWith("/birthday-settings") ||
    location.pathname.startsWith("/chats");

  const isConfiguracoesActive =
    (location.pathname.startsWith("/settings") &&
      !location.pathname.startsWith("/settings/companies") &&
      !location.pathname.startsWith("/settings/plans") &&
      !location.pathname.startsWith("/settings/helps") &&
      !location.pathname.startsWith("/settings/whitelabel") &&
      !location.pathname.startsWith("/settings/system")) ||
    location.pathname.startsWith("/users");

  useEffect(() => {
    if (location.pathname.startsWith("/schedules") || location.pathname.startsWith("/calcom-integration")) {
      setOpenSchedulingSubmenu(true);
    } else if (location.pathname.startsWith("/settings/companies") || location.pathname.startsWith("/settings/plans") || location.pathname.startsWith("/settings/helps") || location.pathname.startsWith("/settings/whitelabel") || location.pathname.startsWith("/settings/system") || location.pathname.startsWith("/companies") || location.pathname.startsWith("/announcements") || location.pathname.startsWith("/allConnections")) {
      setOpenGerenciaSubmenu(true);
      setOpenConfiguracoesSubmenu(false);
    } else if (isCrmActive) {
      setOpenCrmSubmenu(true);
    } else if (isConfiguracoesActive) {
      setOpenConfiguracoesSubmenu(true);
      setOpenGerenciaSubmenu(false);
    }
  }, [location, isCrmActive, isConfiguracoesActive]);

  const { getPlanCompany } = usePlans();

  const { getVersion } = useVersion();

  useEffect(() => {
    async function fetchVersion() {
      const _version = await getVersion();
      setVersion(_version.version);
    }
    fetchVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowCampaigns(planConfigs.plan.useCampaigns);
      setShowKanban(planConfigs.plan.useKanban);
      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
      setShowSchedules(planConfigs.plan.useSchedules);
      setShowInternalChat(planConfigs.plan.useInternalChat);
      setShowExternalApi(planConfigs.plan.useExternalApi);
      setShowWavoipCall(planConfigs.plan.wavoip);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchChats();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);

  useEffect(() => {
    if (user.id && socket && typeof socket.on === 'function') {
      const companyId = user.companyId;

      const onCompanyChatMainListItems = (data) => {
        if (data.action === "new-message") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
        if (data.action === "update") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
      };

      const eventName = `company-${companyId}-chat`;
      console.log('Registrando listener para:', eventName);

      socket.on(eventName, onCompanyChatMainListItems);

      return () => {
        if (socket && typeof socket.off === 'function') {
          console.log('Removendo listener para:', eventName);
          socket.off(eventName, onCompanyChatMainListItems);
        }
      };
    }
  }, [socket, user.id, user.companyId]);

  useEffect(() => {
    let unreadsCount = 0;
    if (chats.length > 0) {
      for (let chat of chats) {
        for (let chatUser of chat.users) {
          if (chatUser.userId === user.id) {
            unreadsCount += chatUser.unreads;
          }
        }
      }
    }
    if (unreadsCount > 0) {
      setInvisible(false);
    } else {
      setInvisible(true);
    }
  }, [chats, user.id]);

  // useEffect(() => {
  //   if (localStorage.getItem("cshow")) {
  //     setShowCampaigns(true);
  //   }
  // }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  const fetchChats = async () => {
    try {
      const { data } = await api.get("/chats/", {
        params: { searchParam, pageNumber },
      });
      dispatch({ type: "LOAD_CHATS", payload: data.records });
    } catch (err) {
      toastError(err);
    }
  };

  const handleAudioToggle = () => {
    const newState = !audioEnabled;
    setAudioEnabled(newState);
    localStorage.setItem("audioEnabled", JSON.stringify(newState));
  };

  const handleVolumeChange = (event, newValue) => {
    setVolume(newValue);
    localStorage.setItem("volume", newValue.toString());
  };

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem(`language_${user.id}`, lng);
    localStorage.setItem("i18nextLng", lng);
    setLanguageAnchor(null);
  };

  // Se super: true, mostrar apenas menu admin geral
  if (user.super) {
    return (
      <div onClick={drawerClose}>
        {/* Seção de Perfil do Usuário no Topo */}
        {!collapsed && (
          <Box style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "18px 12px",
            borderBottom: `2px solid ${theme.mode === "light" ? "rgba(0,0,0,0.08)" : "rgba(255,255,255,0.1)"}`,
            gap: "12px",
            background: theme.mode === "light" 
              ? "linear-gradient(135deg, rgba(0,0,0,0.01) 0%, rgba(0,0,0,0.02) 100%)"
              : "linear-gradient(135deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.03) 100%)",
          }}>
            {/* Avatar */}
            <Tooltip title="Clique para editar perfil">
              <Avatar
                alt={user?.name || "User"}
                src={profileUrl}
                onClick={onProfileClick}
                style={{
                  width: 75,
                  height: 75,
                  cursor: "pointer",
                  border: `3px solid ${theme.palette.primary.main}`,
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  boxShadow: `0 4px 12px ${theme.palette.primary.main}20`,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.12)";
                  e.currentTarget.style.boxShadow = `0 8px 20px ${theme.palette.primary.main}40`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = `0 4px 12px ${theme.palette.primary.main}20`;
                }}
              />
            </Tooltip>

            {/* Boas-vindas e Nome */}
            <Box style={{ textAlign: "center" }}>
              <Typography style={{ fontSize: "11px", color: theme.mode === "light" ? "#999" : "#aaa", fontWeight: 500, letterSpacing: "0.5px" }}>
                BEM-VINDO(A)
              </Typography>
              <Typography style={{ fontSize: "16px", fontWeight: 700, color: theme.palette.primary.main, marginTop: "2px" }}>
                {user?.name || "Usuário"}
              </Typography>
            </Box>

            {/* Perfil do Usuário */}
            <Box style={{ 
              textAlign: "center", 
              width: "100%",
              padding: "8px 12px",
              backgroundColor: theme.mode === "light" 
                ? "rgba(0,0,0,0.03)" 
                : "rgba(255,255,255,0.08)",
              borderRadius: "10px",
              fontSize: "11px",
              border: `1px solid ${theme.palette.primary.main}20`,
              transition: "all 0.3s ease",
            }}>
              <Typography style={{ 
                fontSize: "10px", 
                color: theme.palette.primary.main,
                fontWeight: 700,
                letterSpacing: "0.3px",
                textTransform: "uppercase"
              }}>
                {user?.profile === "admin" ? "Administrador" : user?.profile === "user" ? "Usuário" : user?.profile}
              </Typography>
            </Box>
          </Box>
        )}

        <Divider className={classes.divider} />

        {/* Menu Admin Geral - Items individuais para super: true */}
        <ListItemLink
          to="/companies"
          primary="Status"
          icon={<BusinessIcon />}
          tooltip={collapsed}
        />
        <ListItemLink
          to="/settings/companies"
          primary="Empresas"
          icon={<BusinessIcon />}
          tooltip={collapsed}
        />
        <ListItemLink
          to="/settings/plans"
          primary="Planos"
          icon={<ShoppingCart />}
          tooltip={collapsed}
        />
        <ListItemLink
          to="/announcements"
          primary="Informativos"
          icon={<AnnouncementIcon />}
          tooltip={collapsed}
        />
        <ListItemLink
          to="/allConnections"
          primary="Todas Conexões"
          icon={<Wifi />}
          tooltip={collapsed}
        />
        <ListItemLink
          to="/settings/helps"
          primary="Ajudas"
          icon={<Help />}
          tooltip={collapsed}
        />
        <ListItemLink
          to="/settings/whitelabel"
          primary="Aparência"
          icon={<Palette />}
          tooltip={collapsed}
        />
        <ListItemLink
          to="/settings/system"
          primary="Sistema"
          icon={<TuneIcon />}
          tooltip={collapsed}
        />
        <ListItemLink
          to="/admin-support-tickets"
          primary="Tickets Suporte"
          icon={<SupportAgentIcon />}
          tooltip={collapsed}
        />

        {/* Botão de Logout */}
        <Divider className={classes.divider} style={{ marginTop: "auto" }} />

        <Tooltip title={collapsed ? "Sair" : ""} placement="right">
          <ListItem
            button
            onClick={onLogout}
            className={classes.listItem}
            style={{ 
              margin: collapsed ? "6px 12px" : "4px 8px",
              padding: collapsed ? "12px 8px" : "8px 12px",
              justifyContent: collapsed ? "center" : "flex-start",
              display: "flex",
              marginTop: "auto"
            }}
          >
            <ListItemIcon style={{ minWidth: collapsed ? "auto" : "56px", justifyContent: "center" }}>
              <div className={classes.iconContainer}>
                <LogoutIcon />
              </div>
            </ListItemIcon>
            {!collapsed && (
              <ListItemText
                primary={
                  <Typography className={classes.listItemText}>
                    Sair
                  </Typography>
                }
              />
            )}
          </ListItem>
        </Tooltip>

        {!collapsed && (
          <React.Fragment>
            <Divider />
          </React.Fragment>
        )}
      </div>
    );
  }

  return (
    <div onClick={drawerClose}>
      {/* Seção de Perfil do Usuário no Topo */}
      {!collapsed && (
        <Box style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "18px 12px",
          borderBottom: `2px solid ${theme.mode === "light" ? "rgba(0,0,0,0.08)" : "rgba(255,255,255,0.1)"}`,
          gap: "12px",
          background: theme.mode === "light" 
            ? "linear-gradient(135deg, rgba(0,0,0,0.01) 0%, rgba(0,0,0,0.02) 100%)"
            : "linear-gradient(135deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.03) 100%)",
        }}>
          {/* Avatar */}
          <Tooltip title="Clique para editar perfil">
            <Avatar
              alt={user?.name || "User"}
              src={profileUrl}
              onClick={onProfileClick}
              style={{
                width: 75,
                height: 75,
                cursor: "pointer",
                border: `3px solid ${theme.palette.primary.main}`,
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: `0 4px 12px ${theme.palette.primary.main}20`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.12)";
                e.currentTarget.style.boxShadow = `0 8px 20px ${theme.palette.primary.main}40`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = `0 4px 12px ${theme.palette.primary.main}20`;
              }}
            />
          </Tooltip>

          {/* Boas-vindas e Nome */}
          <Box style={{ textAlign: "center" }}>
            <Typography style={{ fontSize: "11px", color: theme.mode === "light" ? "#999" : "#aaa", fontWeight: 500, letterSpacing: "0.5px" }}>
              BEM-VINDO(A)
            </Typography>
            <Typography style={{ fontSize: "16px", fontWeight: 700, color: theme.palette.primary.main, marginTop: "2px" }}>
              {user?.name || "Usuário"}
            </Typography>
          </Box>

          {/* Informações de Plano e Vencimento */}
          {user?.company && (
            <Box style={{ 
              textAlign: "center", 
              width: "100%",
              padding: "8px 12px",
              backgroundColor: theme.mode === "light" 
                ? "rgba(0,0,0,0.03)" 
                : "rgba(255,255,255,0.08)",
              borderRadius: "10px",
              fontSize: "11px",
              border: `1px solid ${theme.palette.primary.main}20`,
              transition: "all 0.3s ease",
            }}>
              {user?.company?.plan && (
                <Typography style={{ 
                  fontSize: "10px", 
                  color: theme.palette.primary.main,
                  fontWeight: 700,
                  marginBottom: "4px",
                  letterSpacing: "0.3px",
                  textTransform: "uppercase"
                }}>
                  {user.company.plan.name || user.company.plan}
                </Typography>
              )}
              {user?.company?.dueDate && (
                <Typography style={{ 
                  fontSize: "10px", 
                  color: new Date(user.company.dueDate) < new Date() ? "#ef4444" : theme.mode === "light" ? "#64748b" : "#cbd5e1",
                  fontWeight: new Date(user.company.dueDate) < new Date() ? 700 : 500
                }}>
                  Vencimento: {new Date(user.company.dueDate).toLocaleDateString('pt-BR')}
                </Typography>
              )}
            </Box>
          )}

          {/* Ícones */}
          <Box className={classes.iconsContainer} style={{ justifyContent: "center", width: "100%", gap: "4px" }}>
            <Tooltip title="Idioma">
              <IconButton 
                size="small" 
                style={{ color: theme.palette.primary.main, padding: "4px", minWidth: "32px", flexShrink: 0 }}
                onClick={(e) => setLanguageAnchor(e.currentTarget)}
              >
                <GTranslateIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Tema">
              <IconButton size="small" style={{ color: theme.palette.primary.main, padding: "4px", minWidth: "32px", flexShrink: 0 }} onClick={onThemeToggle}>
                <ContrastIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={audioEnabled ? "Desativar áudio" : "Ativar áudio"}>
              <IconButton 
                size="small" 
                style={{ color: theme.palette.primary.main, padding: "4px", minWidth: "32px", flexShrink: 0 }} 
                onClick={(e) => setVolumeAnchor(e.currentTarget)}
              >
                {audioEnabled ? <VolumeUpIcon fontSize="small" /> : <VolumeOffIcon fontSize="small" />}
              </IconButton>
            </Tooltip>
            <Tooltip title="Atualizar">
              <IconButton size="small" style={{ color: theme.palette.primary.main, padding: "4px", minWidth: "32px", flexShrink: 0 }} onClick={onRefresh}>
                <RestartAltIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Informativos">
              <IconButton size="small" style={{ color: theme.palette.primary.main, padding: "4px", minWidth: "32px", flexShrink: 0 }} onClick={onInformativos}>
                <AnnouncementIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      )}

      <Menu
        anchorEl={languageAnchor}
        open={Boolean(languageAnchor)}
        onClose={() => setLanguageAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {LANGUAGE_OPTIONS.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            selected={i18n.language === lang.code}
          >
            {lang.label}
          </MenuItem>
        ))}
      </Menu>

      <Popover
        open={Boolean(volumeAnchor)}
        anchorEl={volumeAnchor}
        onClose={() => setVolumeAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box style={{ padding: "16px", width: "200px" }}>
          <Typography variant="caption" display="block" gutterBottom>
            Volume: {Math.round(volume * 100)}%
          </Typography>
          <Slider
            value={volume}
            onChange={handleVolumeChange}
            min={0}
            max={1}
            step={0.1}
            style={{ marginTop: "8px" }}
          />
          <Box style={{ marginTop: "12px", display: "flex", gap: "8px" }}>
            <Button
              size="small"
              variant={audioEnabled ? "contained" : "outlined"}
              color="primary"
              onClick={handleAudioToggle}
              fullWidth
            >
              {audioEnabled ? "Ativar" : "Desativar"}
            </Button>
          </Box>
        </Box>
      </Popover>

      <Can
        role={
          (user.profile === "user" && user.showDashboard === "enabled") ||
            user.allowRealTime === "enabled"
            ? "admin"
            : user.profile
        }
        perform={"drawer-admin-items:view"}
        yes={() => (
          <>
          </>
        )}
      />
      
      {/* Live Chat - Item direto */}
      <ListItemLink
        to="/tickets"
        primary="Live Chat"
        icon={<ForumIcon />}
        tooltip={collapsed}
      />

      {/* Submenu CRM */}
      <Tooltip
        title={collapsed ? "CRM" : ""}
        placement="right"
      >
        <ListItem
          dense
          button
          onClick={() => setOpenCrmSubmenu((prev) => !prev)}
          onMouseEnter={() => setCrmHover(true)}
          onMouseLeave={() => setCrmHover(false)}
          className={`${classes.listItem} ${isCrmActive || crmHover ? "active" : ""}`}
          style={{ 
            margin: collapsed ? "6px 12px" : "4px 8px",
            padding: collapsed ? "12px 8px" : "8px 12px",
            justifyContent: collapsed ? "center" : "flex-start",
            display: "flex"
          }}
        >
          <ListItemIcon style={{ minWidth: collapsed ? "auto" : "56px", justifyContent: "center" }}>
            <div
              className={`${classes.iconContainer} ${isCrmActive || crmHover ? "active" : ""}`}
            >
              <TornadoIcon />
            </div>
          </ListItemIcon>
          {!collapsed && (
            <ListItemText
              primary={
                <Typography className={classes.listItemText}>
                  CRM
                </Typography>
              }
            />
          )}
          {!collapsed && (
            <ExpandMoreIcon 
              className={`${classes.expandIcon} ${openCrmSubmenu ? "expanded" : ""}`}
            />
          )}
        </ListItem>
      </Tooltip>
      <Collapse
        in={openCrmSubmenu}
        timeout="auto"
        unmountOnExit
        className={classes.submenuContainer}
      >
        <List dense component="div" disablePadding className={classes.submenuContainer}>
          {showInternalChat && (
            <ListItemLink
              small
              to="/chats"
              primary="Chat Interno"
              icon={
                <Badge color="secondary" variant="dot" invisible={invisible}>
                  <ForumIcon />
                </Badge>
              }
              tooltip={collapsed}
            />
          )}
          {showKanban && (
            <ListItemLink
              small
              to="/kanban"
              primary={i18n.t("mainDrawer.listItems.kanban")}
              icon={<ViewKanbanIcon />}
              tooltip={collapsed}
            />
          )}
          <ListItemLink
            small
            to="/tags"
            primary={i18n.t("mainDrawer.listItems.tags")}
            icon={<LocalOfferIcon />}
            tooltip={collapsed}
          />
          {user.showContacts === "enabled" && (
            <ListItemLink
              small
              to="/contacts"
              primary={i18n.t("mainDrawer.listItems.contacts")}
              icon={<ContactsIcon />}
              tooltip={collapsed}
            />
          )}
          {user.profile === "admin" && showWallets && (
            <ListItemLink
              small
              to="/wallets"
              primary="Carteira Cliente"
              icon={<AccountBalanceWalletIcon />}
              tooltip={collapsed}
            />
          )}
          <ListItemLink
            small
            to="/quick-messages"
            primary={i18n.t("mainDrawer.listItems.quickMessages")}
            icon={<BoltIcon />}
            tooltip={collapsed}
          />
          {showWavoipCall && (
            <ListItemLink
              small
              to="/call-historicals"
              primary="H. Ligações"
              icon={<CallIcon />}
              tooltip={collapsed}
            />
          )}
          <Can
            role={user.profile}
            perform="dashboard:view"
            yes={() => (
              <ListItemLink
                small
                to="/queues"
                primary="Setor"
                icon={<AccountTreeIcon />}
                tooltip={collapsed}
              />
            )}
          />
          <Can
            role={user.profile}
            perform="dashboard:view"
            yes={() => (
              <ListItemLink
                small
                to="/birthday-settings"
                primary="Config. Aniversário"
                icon={<CakeIcon />}
                tooltip={collapsed}
              />
            )}
          />
        </List>
      </Collapse>

      {/* Submenu Agendamentos */}
      <Tooltip
        title={collapsed ? "Agendamentos" : ""}
        placement="right"
      >
        <ListItem
          dense
          button
          onClick={() => setOpenSchedulingSubmenu((prev) => !prev)}
          onMouseEnter={() => setSchedulingHover(true)}
          onMouseLeave={() => setSchedulingHover(false)}
          className={`${classes.listItem} ${isSchedulingActive || schedulingHover ? "active" : ""}`}
          style={{ 
            margin: collapsed ? "6px 12px" : "4px 8px",
            padding: collapsed ? "12px 8px" : "8px 12px",
            justifyContent: collapsed ? "center" : "flex-start",
            display: "flex"
          }}
        >
          <ListItemIcon style={{ minWidth: collapsed ? "auto" : "56px", justifyContent: "center" }}>
            <div
              className={`${classes.iconContainer} ${isSchedulingActive || schedulingHover ? "active" : ""}`}
            >
              <TodayIcon />
            </div>
          </ListItemIcon>
          {!collapsed && (
            <ListItemText
              primary={
                <Typography className={classes.listItemText}>
                  Agendamentos
                </Typography>
              }
            />
          )}
          {!collapsed && (
            <ExpandMoreIcon 
              className={`${classes.expandIcon} ${openSchedulingSubmenu ? "expanded" : ""}`}
            />
          )}
        </ListItem>
      </Tooltip>
      <Collapse
        in={openSchedulingSubmenu}
        timeout="auto"
        unmountOnExit
        className={classes.submenuContainer}
      >
        <List dense component="div" disablePadding className={classes.submenuContainer}>
          {showSchedules && (
            <ListItemLink
              to="/schedules"
              primary="Msg Programada"
              icon={<WhatsAppIcon />}
              tooltip={collapsed}
            />
          )}
          <ListItemLink
            to="/calcom-integration"
            primary="Cal Agenda"
            icon={<TodayIcon />}
            tooltip={collapsed}
          />
        </List>
      </Collapse>

      {/* Ajuda movida para Central de Apps */}
      {false && hasHelps && (
        <ListItemLink
          to="/helps"
          primary={i18n.t("mainDrawer.listItems.helps")}
          icon={<HelpOutlineIcon />}
          tooltip={collapsed}
        />
      )}

      {user?.showCampaign === "enabled" && showCampaigns && (
        <>
          <Tooltip
            title={collapsed ? "Disparador" : ""}
            placement="right"
          >
            <ListItem
              dense
              button
              onClick={() => setOpenCampaignSubmenu((prev) => !prev)}
              onMouseEnter={() => setCampaignHover(true)}
              onMouseLeave={() => setCampaignHover(false)}
              className={`${classes.listItem} ${isCampaignRouteActive || campaignHover ? "active" : ""}`}
              style={{ 
                margin: collapsed ? "6px 12px" : "4px 8px",
                padding: collapsed ? "12px 8px" : "8px 12px",
                justifyContent: collapsed ? "center" : "flex-start",
                display: "flex"
              }}
            >
              <ListItemIcon style={{ minWidth: collapsed ? "auto" : "56px", justifyContent: "center" }}>
                <div
                  className={`${classes.iconContainer} ${isCampaignRouteActive || campaignHover ? "active" : ""}`}
                >
                  <OfflineBoltIcon />
                </div>
              </ListItemIcon>
              {!collapsed && (
                <ListItemText
                  primary={
                    <Typography className={classes.listItemText}>
                      Disparador
                    </Typography>
                  }
                />
              )}
              {!collapsed && (
                <ExpandMoreIcon 
                  className={`${classes.expandIcon} ${openCampaignSubmenu ? "expanded" : ""}`}
                />
              )}
            </ListItem>
          </Tooltip>
          <Collapse
            in={openCampaignSubmenu}
            timeout="auto"
            unmountOnExit
            className={classes.submenuContainer}
          >
            <List dense component="div" disablePadding className={classes.submenuContainer}>
              <ListItemLink
                to="/campaigns"
                primary="Disparo em Massa"
                icon={<PlaylistAdd />}
                tooltip={collapsed}
              />
              <ListItemLink
                to="/contact-lists"
                primary={i18n.t("campaigns.subMenus.listContacts")}
                icon={<ContactMail />}
                tooltip={collapsed}
              />
            </List>
          </Collapse>
        </>
      )}

      {/* FLOWBUILDER */}
      {user.showFlow === "enabled" && (
        <>
          <Tooltip
            title={
              collapsed ? "Disparador" : ""
            }
            placement="right"
          >
            <ListItem
              dense
              button
              onClick={() => setOpenFlowSubmenu((prev) => !prev)}
              onMouseEnter={() => setFlowHover(true)}
              onMouseLeave={() => setFlowHover(false)}
              className={`${classes.listItem} ${isFlowbuilderRouteActive || flowHover ? "active" : ""}`}
              style={{ 
                margin: collapsed ? "6px 12px" : "4px 8px",
                padding: collapsed ? "12px 8px" : "8px 12px",
                justifyContent: collapsed ? "center" : "flex-start"
              }}
            >
              <ListItemIcon style={{ minWidth: collapsed ? "auto" : "56px", justifyContent: "center" }}>
                <div
                  className={`${classes.iconContainer} ${isFlowbuilderRouteActive || flowHover ? "active" : ""}`}
                >
                  <SmartToyIcon />
                </div>
              </ListItemIcon>
              {!collapsed && (
                <ListItemText
                  primary={
                    <Typography className={classes.listItemText}>
                      {i18n.t("mainDrawer.listItems.automations")}
                    </Typography>
                  }
                />
              )}
              {!collapsed && (
                <ExpandMoreIcon 
                  className={`${classes.expandIcon} ${openFlowSubmenu ? "expanded" : ""}`}
                />
              )}
            </ListItem>
          </Tooltip>

          <Collapse
            in={openFlowSubmenu}
            timeout="auto"
            unmountOnExit
            className={classes.submenuContainer}
          >
            <List dense component="div" disablePadding className={classes.submenuContainer}>
              <ListItemLink
                to="/phrase-lists"
                primary={"Fluxo de Campanha"}
                icon={<AutoGraph />}
                tooltip={collapsed}
              />

              <ListItemLink
                to="/flowbuilders"
                primary={"Fluxo de conversa"}
                icon={<SensorOccupiedIcon />}
                tooltip={collapsed}
              />

              <ListItemLink
                to="/plugins/floup"
                primary={"Config. Follow UP"}
                icon={<IntegrationInstructions />}
                tooltip={collapsed}
              />
            </List>
          </Collapse>
        </>
      )}

      {/* Conexões - Item Principal */}
      <Can
        role={
          user.profile === "user" && user.allowConnections === "enabled"
            ? "admin"
            : user.profile
        }
        perform={"drawer-admin-items:view"}
        yes={() => (
          <ListItemLink
            to="/connections"
            primary={i18n.t("mainDrawer.listItems.connections")}
            icon={
              connectionWarning ? (
                <Badge
                  badgeContent="!"
                  color="error"
                  overlap="circular"
                  className={classes.badge}
                >
                  <LinkIcon />
                </Badge>
              ) : (
                <LinkIcon />
              )
            }
            tooltip={collapsed}
          />
        )}
      />

      {/* Submenu Relatórios */}
      {(user.profile === "admin" ||
        user.showDashboard === "enabled" ||
        user.allowRealTime === "enabled") && (
      <>
      <Tooltip
        title={collapsed ? "Relatórios" : ""}
        placement="right"
      >
        <ListItem
          dense
          button
          onClick={() => setOpenDashboardSubmenu((prev) => !prev)}
          onMouseEnter={() => setManagementHover(true)}
          onMouseLeave={() => setManagementHover(false)}
          className={`${classes.listItem} ${isManagementActive || managementHover ? "active" : ""}`}
          style={{ 
            margin: collapsed ? "6px 12px" : "4px 8px",
            padding: collapsed ? "12px 8px" : "8px 12px",
            justifyContent: collapsed ? "center" : "flex-start"
          }}
        >
          <ListItemIcon style={{ minWidth: collapsed ? "auto" : "56px", justifyContent: "center" }}>
            <div
              className={`${classes.iconContainer} ${isManagementActive || managementHover ? "active" : ""}`}
            >
              <BarChart />
            </div>
          </ListItemIcon>
          {!collapsed && (
            <ListItemText
              primary={
                <Typography className={classes.listItemText}>
                  Relatórios
                </Typography>
              }
            />
          )}
          {!collapsed && (
            <ExpandMoreIcon 
              className={`${classes.expandIcon} ${openDashboardSubmenu ? "expanded" : ""}`}
            />
          )}
        </ListItem>
      </Tooltip>
      <Collapse
        in={openDashboardSubmenu}
        timeout="auto"
        unmountOnExit
        className={classes.submenuContainer}
      >
        <Can
          role={
            user.profile === "user" && user.showDashboard === "enabled"
              ? "admin"
              : user.profile
          }
          perform={"drawer-admin-items:view"}
          yes={() => (
            <>
              <ListItemLink
                small
                to="/"
                primary="Dashboard"
                icon={<BarChart />}
                tooltip={collapsed}
              />
              <ListItemLink
                small
                to="/reports"
                primary={i18n.t("mainDrawer.listItems.reports")}
                icon={<Assessment />}
                tooltip={collapsed}
              />
            </>
          )}
        />
        <Can
          role={
            user.profile === "user" && user.allowRealTime === "enabled"
              ? "admin"
              : user.profile
          }
          perform={"drawer-admin-items:view"}
          yes={() => (
            <ListItemLink
              to="/moments"
              primary="View 360"
              icon={<GridView />}
              tooltip={collapsed}
            />
          )}
        />
        <Can
          role={user.profile}
          perform="dashboard:view"
          yes={() => (
            user.profile === "admin" && (
              <ListItemLink
                small
                to="/plugins/floup/dashboard"
                primary="Hub Follow"
                icon={<ViewKanbanIcon />}
                tooltip={collapsed}
              />
            )
          )}
        />
      </Collapse>
      </>
      )}

      {/* Financeiro */}
      <Can
        role={user.profile}
        perform="dashboard:view"
        yes={() => (
          <ListItemLink
            to="/financeiro"
            primary={i18n.t("mainDrawer.listItems.financeiro")}
            icon={<LocalAtmIcon />}
            tooltip={collapsed}
          />
        )}
      />

      {/* Submenu Configurações */}
      <Can
        role={
          user.profile === "user" && user.allowConnections === "enabled"
            ? "admin"
            : user.profile
        }
        perform="dashboard:view"
        yes={() => (
          <>
            <Tooltip
              title={collapsed ? "Configurações" : ""}
              placement="right"
            >
              <ListItem
                dense
                button
                onClick={() => {
                  setOpenConfiguracoesSubmenu((prev) => !prev);
                  setOpenGerenciaSubmenu(false);
                }}
                onMouseEnter={() => setConfiguracoesHover(true)}
                onMouseLeave={() => setConfiguracoesHover(false)}
                className={`${classes.listItem} ${isConfiguracoesActive || configuracoesHover ? "active" : ""}`}
                style={{ 
                  margin: collapsed ? "6px 12px" : "4px 8px",
                  padding: collapsed ? "12px 8px" : "8px 12px",
                  justifyContent: collapsed ? "center" : "flex-start",
                  display: "flex"
                }}
              >
                <ListItemIcon style={{ minWidth: collapsed ? "auto" : "56px", justifyContent: "center" }}>
                  <div
                    className={`${classes.iconContainer} ${isConfiguracoesActive || configuracoesHover ? "active" : ""}`}
                  >
                    <TuneIcon />
                  </div>
                </ListItemIcon>
                {!collapsed && (
                  <ListItemText
                    primary={
                      <Typography className={classes.listItemText}>
                        Configurações
                      </Typography>
                    }
                  />
                )}
                {!collapsed && (
                  <ExpandMoreIcon 
                    className={`${classes.expandIcon} ${openConfiguracoesSubmenu ? "expanded" : ""}`}
                  />
                )}
              </ListItem>
            </Tooltip>
            <Collapse
              in={openConfiguracoesSubmenu}
              timeout="auto"
              unmountOnExit
              className={classes.submenuContainer}
            >
              <List dense component="div" disablePadding className={classes.submenuContainer}>
                <Can
                  role={user.profile}
                  perform="dashboard:view"
                  yes={() => (
                    <ListItemLink
                      small
                      to="/settings"
                      primary="Geral"
                      icon={<TuneIcon />}
                      tooltip={collapsed}
                    />
                  )}
                />
                <Can
                  role={user.profile}
                  perform="dashboard:view"
                  yes={() => (
                    <ListItemLink
                      small
                      to="/users"
                      primary="Usuários"
                      icon={<PersonIcon />}
                      tooltip={collapsed}
                    />
                  )}
                />
              </List>
            </Collapse>
          </>
        )}
      />

      {/* Submenu Gerência (Apenas Super Admin) */}
      {user.super && (
        <Can
          role={user.profile}
          perform="dashboard:view"
          yes={() => (
            <>
              <Tooltip
                title={collapsed ? "Gerência" : ""}
                placement="right"
              >
                <ListItem
                  dense
                  button
                  onClick={() => {
                    setOpenGerenciaSubmenu((prev) => !prev);
                    setOpenConfiguracoesSubmenu(false);
                  }}
                  onMouseEnter={() => setGerenciaHover(true)}
                  onMouseLeave={() => setGerenciaHover(false)}
                  className={`${classes.listItem} ${gerenciaHover ? "active" : ""}`}
                  style={{ 
                    margin: collapsed ? "6px 12px" : "4px 8px",
                    padding: collapsed ? "12px 8px" : "8px 12px",
                    justifyContent: collapsed ? "center" : "flex-start",
                    display: "flex"
                  }}
                >
                  <ListItemIcon style={{ minWidth: collapsed ? "auto" : "56px", justifyContent: "center" }}>
                    <div
                      className={`${classes.iconContainer} ${gerenciaHover ? "active" : ""}`}
                    >
                      <AdminPanelSettingsIcon />
                    </div>
                  </ListItemIcon>
                  {!collapsed && (
                    <ListItemText
                      primary={
                        <Typography className={classes.listItemText}>
                          Gerência
                        </Typography>
                      }
                    />
                  )}
                  {!collapsed && (
                    <ExpandMoreIcon 
                      className={`${classes.expandIcon} ${openGerenciaSubmenu ? "expanded" : ""}`}
                    />
                  )}
                </ListItem>
              </Tooltip>
              <Collapse
                in={openGerenciaSubmenu}
                timeout="auto"
                unmountOnExit
                className={classes.submenuContainer}
              >
              <List dense component="div" disablePadding className={classes.submenuContainer}>
                <ListItemLink
                  small
                  to="/companies"
                  primary="Status"
                  icon={<BusinessIcon />}
                  tooltip={collapsed}
                />
                <ListItemLink
                  small
                  to="/settings/companies"
                  primary="Empresas"
                  icon={<BusinessIcon />}
                  tooltip={collapsed}
                />
                <ListItemLink
                  small
                  to="/settings/plans"
                  primary="Planos"
                  icon={<ShoppingCart />}
                  tooltip={collapsed}
                />
                <ListItemLink
                  small
                  to="/announcements"
                  primary="Informativos"
                  icon={<AnnouncementIcon />}
                  tooltip={collapsed}
                />
                <ListItemLink
                  small
                  to="/allConnections"
                  primary="Todas Conexões"
                  icon={<Wifi />}
                  tooltip={collapsed}
                />
                <ListItemLink
                  small
                  to="/settings/helps"
                  primary="Ajudas"
                  icon={<Help />}
                  tooltip={collapsed}
                />
                <ListItemLink
                  small
                  to="/settings/whitelabel"
                  primary="Aparência"
                  icon={<Palette />}
                  tooltip={collapsed}
                />
                <ListItemLink
                  small
                  to="/settings/system"
                  primary="Sistema"
                  icon={<TuneIcon />}
                  tooltip={collapsed}
                />
                <ListItemLink
                  small
                  to="/admin-support-tickets"
                  primary="Tickets Suporte"
                  icon={<SupportAgentIcon />}
                  tooltip={collapsed}
                />
              </List>
            </Collapse>
          </>
        )}
      />
      )}

      {/* Apps - Link direto */}
      <Can
        role={
          user.profile === "user" && user.allowConnections === "enabled"
            ? "admin"
            : user.profile
        }
        perform="dashboard:view"
        yes={() => (
          <ListItemLink
            to="/apps"
            primary="Apps"
            icon={<Extension />}
            tooltip={collapsed}
          />
        )}
      />

      {/* Botão de Logout */}
      <Divider className={classes.divider} />
      <Tooltip title={collapsed ? "Sair" : ""} placement="right">
        <ListItem
          button
          dense
          onClick={onLogout}
          style={{
            margin: collapsed ? "6px 12px" : "4px 8px",
            padding: collapsed ? "12px 8px" : "8px 12px",
            borderRadius: "8px",
            color: "#ef4444",
            transition: "all 0.2s ease",
            justifyContent: collapsed ? "center" : "flex-start",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(239, 68, 68, 0.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          <ListItemIcon style={{ minWidth: collapsed ? "auto" : "56px", justifyContent: "center", color: "#ef4444" }}>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          {!collapsed && (
            <ListItemText
              primary={
                <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
                  Sair
                </Typography>
              }
            />
          )}
        </ListItem>
      </Tooltip>

      <Can
        role={
          user.profile === "user" && user.allowConnections === "enabled"
            ? "admin"
            : user.profile
        }
        perform="dashboard:view"
        yes={() => (
          <>
            <Divider className={classes.divider} />
          </>
        )}
      />
      {!collapsed && (
        <React.Fragment>
          <Divider />
          <Typography
            style={{
              fontSize: "12px",
              padding: "10px",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
          </Typography>
        </React.Fragment>
      )}
    </div>
  );
};

export default MainListItems;
